import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import BigCalendar from 'react-big-calendar';
import { listenForFirebaseItems } from './firebase-helpers'
import {  map, pipe, values, assoc, objOf, mergeAll } from 'ramda'
import moment from 'moment';
import 'moment/locale/en-gb';
import * as firebase from 'firebase'

import './Calendar.css'

class Calendar extends FirebaseComponent {
  constructor() {
		super()

    this.state = { events: [] }
    this.getEvents = this.getEvents.bind(this)
    BigCalendar.momentLocalizer(moment)

		const convertCompetencies = pipe(
			map(assoc('allDay', true)),
			map(c => assoc('start', c.endDate)(c)),
			map(c => assoc('end', c.endDate)(c)),
			objOf('competencies')
		)

		const convertPassports = pipe(
			map(assoc('allDay', true)),
			map(p => assoc('title', `${p.countryOfIssue} passport expires`)(p)),
			map(p => assoc('start', p.endDate)(p)),
			map(p => assoc('end', p.endDate)(p)),
			objOf('passports')
		)

		const convertEvents = pipe(
			map(assoc('allDay', true)),
			map(p => assoc('start', p.startDate)(p)),
			map(p => assoc('end', p.endDate)(p)),
			objOf('customEvents')
		)

		const convertVisas = pipe(
			map(assoc('allDay', true)),
			map(p => assoc('title', `${p.countryOfIssue} visa expires`)(p)),
			map(p => assoc('start', p.endDate)(p)),
			map(p => assoc('end', p.endDate)(p)),
			objOf('visas')
		)

		const convertShifts = pipe(
			map(assoc('allDay', true)),
			map(assoc('title', 'Shift')),
			map(s => assoc('start', s.startDate)(s)),
			map(s => assoc('end', s.endDate)(s)),
			objOf('shifts')
		)

		const convertMedicals = pipe(
			map(assoc('allDay', true)),
			map(p => assoc('title', `${p.title} expires`)(p)),
			map(s => assoc('start', s.endDate)(s)),
			map(s => assoc('end', s.endDate)(s)),
			objOf('medicals')
		)

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        listenForFirebaseItems('competencies', competencies => {
          this.setState(convertCompetencies(competencies))
        })

        listenForFirebaseItems('passports', passports => {
          this.setState(convertPassports(passports))
        })

        listenForFirebaseItems('shifts', shifts => {
          this.setState(convertShifts(shifts))
        })

        listenForFirebaseItems('visas', visas => {
          this.setState(convertVisas(visas))
        })

        listenForFirebaseItems('events', events => {
          this.setState(convertEvents(events))
        })

        listenForFirebaseItems('medicals', medicals => {
          this.setState(convertMedicals(medicals))
        })
      }
    })
  }

  getEvents() {
    return values(mergeAll([
      this.state.competencies,
      this.state.passports,
      this.state.shifts,
      this.state.visas,
      this.state.customEvents,
      this.state.medicals
    ]))
  }


  render() {
    return (
      <div>
				<BigCalendar
					events={this.getEvents()}
          views={['month']}
				/>
      </div>
    )
  }
}

export default Calendar



// WEBPACK FOOTER //
// ./src/Calendar.js